import { CHANGE_FILE_OFFSET } from '../actionTypes'

export const changeFileOffset = (fileName: string, offset: number) => ({
  type: CHANGE_FILE_OFFSET,
  payload: { src_file: fileName, upload_length: offset },
})
